export default {
    items: [
        {
            Name: 'financial_management',
            Icon: 'fa fa-calendar',
            Children: [
                {
                    Name: 'expense',
                    Url: '/expenses',
                    Icon: ' fa fa-folder-open'
                },
                {
                    Name: 'general_journal',
                    Url: '/accounting/journals',
                    Icon: 'fa fa-folder-open'
                },
                {
                    Name: 'coa',
                    Url: '/accounting/accounts',
                    Icon: 'fa fa-sitemap'
                }
            ]
        },
        {
            Name: 'employee_management',
            Icon: 'fa fa-user-plus',
            Children: [
                {
                    Name: 'employee_list',
                    Url: '/employees',
                    Icon: 'fa fa-user-secret'
                },
                {
                    Name: 'payroll',
                    Url: '/payrolls',
                    Icon: 'fa fa-usd'
                },
                {
                    Name: 'discipline',
                    Url: '/discipline/list',
                    Icon: 'fa fa-exclamation-triangle'
                },
                {
                    Name: 'monthly_allowance',
                    Url: '/employee/monthly/allowances',
                    Icon: 'fa fa-gift'
                },
                {
                    Name: 'allowance',
                    Url: '/allowances',
                    Icon: 'fa fa-bug'
                },
                {
                    Name: 'job',
                    Url: '/positions',
                    Icon: 'fa fa-tasks'
                }
            ]
        },
        {
            Name: 'leave_management',
            Icon: 'fa fa-snowflake-o',
            Children: [
                {
                    Name: 'leave_app',
                    Url: '/applications',
                    Icon: 'fa fa-handshake-o'
                },
                {
                    Name: 'leave_apply_scheme',
                    Url: '/apply/schemes',
                    Icon: 'fa fa-creative-commons'
                },
                {
                    Name: 'leave_category',
                    Url: '/leaves',
                    Icon: 'fa fa-eye',
                },
                {
                    Name: 'leave_scheme',
                    Url: '/schemes',
                    Icon: 'fa fa-sitemap',
                }
            ]
        }
    ],
    menus: [
        {
            Name: 'main_data',
            Url: '/item',
            Icon: 'fa fa-user-plus'
        },
        // {
        //     Name: 'settings',
        //     Children: [
        //         {
        //             Name: 'branch',
        //             Url: '/branch'
        //         },
        //         {
        //             Name: 'brand_list',
        //             Url: '/brands'
        //         },
        //         {
        //             Name: 'uom_list',
        //             Url: '/uom'
        //         },
        //         {
        //             Name: 'item_category_list',
        //             Url: '/category'
        //         },
        //         {
        //             Name: 'exchange_rate',
        //             Url: '/exchangerates'
        //         },
        //         {
        //             Name: 'customer_types',
        //             Url: '/customer/types'
        //         },
        //         {
        //             Name: 'public_holiday',
        //             Url: '/holiday'
        //         },
        //         {
        //             Name: 'configuration',
        //             Url: '/configuration'
        //         }
        //     ]
        // },
        {
            Name: 'reports',
            Url: '/reports'
        },
        {
            Name: 'help',
            Url: '/help'
        }
    ]
}
